export enum EAppointmentType {
    NONE = "0",
    BRANCH = "1",
    VIRTUAL = "2",
}
  